import Image from 'next/image';

import type { ManageSIPPropsType } from '@/types/manageSip';
import {
  getCycleName,
  getDayByDate,
  getFormattedDate,
  getSipFrequency,
  getSipImage,
  getSipStatusIcon,
  sipStatusEnums,
} from '@/utils/functions/SIPs';

export const ManageSIPMobileItem = (props: ManageSIPPropsType) => {
  const { each, onClickSetSIPSummary } = props;

  return (
    <>
      <div className="manage-sip-item-container">
        <div className="manage-sip-mobile-info-container">
          <div className="manage-sip-status-container">
            <Image
              style={{ color: undefined }}
              className="img-fluid mr-2"
              // style={{ marginRight: '8px' }}
              src={getSipStatusIcon(each?.paymentCycle)}
              alt="sip status icon"
            />
            <p className="manage-sip-mobile-cycle">
              {getCycleName(each?.paymentCycle)} SIP
            </p>
          </div>
          <div className="manage-sip-mobile-info-container">
            <p className="manage-sip-mobile-amount">₹{each?.amount}</p>
            <button
              type="button"
              onClick={() => onClickSetSIPSummary(each)}
              className="circleArrow-icon"
            >
              <span className="sr-only">detail</span>
            </button>
          </div>
        </div>
        <p className="manage-sip-mobile-debit">
          Last debit was made on {getFormattedDate(each?.lastDeductionDate)}
        </p>{' '}
        <hr />
        <div className="manage-sip-status-container">
          <div className="manage-sip-status-container">
            {each?.sipStatus ? (
              <Image
                style={{ color: undefined }}
                src={getSipImage(each?.sipStatus)}
                alt=""
                className="manage-sip-status-image"
              />
            ) : null}

            <p className="manage-sip-mobile-status">
              {each?.sipStatus ? sipStatusEnums[each?.sipStatus] : 'NA'}
            </p>
          </div>
          <p className="manage-sip-mobile-status">
            {' '}
            {/* {getCycleName(each?.paymentCycle)} on{' '}
            {getDayByDate(each?.startDate, each?.paymentCycle)} */}
            {getSipFrequency(each?.paymentCycle)}{' '}
            {getDayByDate(each?.startDate, each?.paymentCycle)}
          </p>
        </div>
      </div>
    </>
  );
};
